import {
	accountNumberFieldName,
	bankAccountFieldName,
	bankFieldName,
	routingNumberFieldName,
} from "./paymentMethodConstants";

export const getMappedCopyInfoData = data => {
	if (!data) return;
	if (!data?.bank && !data?.account && !data?.accountName && !data?.routing)
		return;
	const mappedCopyData = {
		[accountNumberFieldName]: data?.account,
		[bankAccountFieldName]: data?.accountName,
		[bankFieldName]: data?.bank,
		[routingNumberFieldName]: data?.routing
			? {
					label: data?.routing,
					value: data?.routing,
			  }
			: {},
	};

	return mappedCopyData;
};
